import React from 'react';
import Alert from 'ui/Alert/Alert';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { translateBlockValue } from 'i18n';
import { getResourceNameField } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { Typography } from '@mui/material';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { ProjectionT } from '../helpers/types';
import ProjectionStatus from './ProjectionStatus';
import { getClientBind } from 'store/APIClient';

type Props = {
    projection: ProjectionT;
    resourceSoftwareId: string;
    budgetProposal: BudgetProposalT;
    canEditProjection: boolean;
    resourceName: string;
    statusField: 'pluriannualProjectionStatus' | 'atterrissageStatus';
};

const StyWarning = styled(Alert, {
    name: 'StyWarning',
})({
    padding: '0.5rem 1rem',
    width: '100%',
    '& .MuiAlert-message': {
        padding: 0,
        display: 'flex',
        alignItems: 'center',
    },
    '& .MuiAlert-action': {
        alignItems: 'center',
        marginRight: 0,
    },
});

const ProjectionBanner = ({
    projection,
    resourceSoftwareId,
    budgetProposal,
    canEditProjection,
    resourceName,
    statusField,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const budgetBy = getResourceNameField(budgetProposal.by);
    const bind = getClientBind();

    if (!canEditProjection) {
        return <></>;
    }
    const article = bind === 'ampmetropole' ? 'cette' : 'ce';
    return (
        <StyWarning
            action={
                <ProjectionStatus
                    resourceSoftwareId={resourceSoftwareId}
                    projection={projection}
                    canEdit={canEditProjection}
                    budgetProposal={budgetProposal} // only for tracking metadata
                    resourceName={resourceName}
                    statusField={statusField}
                />
            }
            severity="info"
        >
            <Typography sx={{ fontSize: '14px' }} display="inline">
                {statusField === 'atterrissageStatus'
                    ? t('projection.atterrissageBannerText', {
                          article,
                      })
                    : t('projection.pluriannualBannerText', { article })}
            </Typography>
            <Typography
                sx={{ fontSize: '14px', fontWeight: '600' }}
                color="primary"
                display="inline"
            >
                {translateBlockValue(budgetBy, true)}
            </Typography>
        </StyWarning>
    );
};
export default ProjectionBanner;
